import React from 'react';
import gravatar from '../../../assets/images/gravatar.png'
export default function MCPayment(){
  return(
    <div className="post-1525 post type-post status-publish format-standard has-post-thumbnail hentry category-news">
<div className="blog-single-post nosidebar">

  <section className="subpage-banner mcpayment-banner"></section>

  <div className="container">

    <div className="row">

      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-2">
                      
            <img src={gravatar} className="author-avatar img-circle img-responsive" alt="Avatar" />            
                                  

          </div>          

          <div className="col-sm-10">

            <h2 className="post-title">Startup bags funds from Singapore ex-minister to get ultra-wealthy into crowdlending</h2>
            <div className="row meta-info">
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-clock"></i>3 May 2018</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-comments"></i>No Comments</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-eye"></i>238 Views</span></div>
                            <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-tag"></i><a href="/news/" rel="category tag">News</a></span></div>
                          </div>

            <div className="post-article"><p>(Read more at https://www.techinasia.com/helicap-seed-funding)</p>
<p>Singapore-based Helicap is a new fintech platform that aims to bring a fund management angle in the peer-to-peer (P2P) lending space. To make this happen, it has raised US$1.5 million in seed funding.</p>
</div>

            <hr></hr>
            
            <div className="social-share">
              <div className="row">
                <div className="col-xs-6 share-text">Share</div>
                <div className="col-xs-6 share-button">
                  <div className="btn-group">
                    <a href="https://www.facebook.com/sharer/sharer.php?u=https://33-capital.com/mc-payment-takes-long-view-on-going-cashless/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
                    <a href="https://plus.google.com/share?url=https://33-capital.com/mc-payment-takes-long-view-on-going-cashless/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-gplus"></i></a>
                    <a href="https://twitter.com/intent/tweet?text=Startup bags funds from Singapore ex-minister to get ultra-wealthy into crowdlending&amp;url=https://33-capital.com/mc-payment-takes-long-view-on-going-cashless/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-twitter"></i></a>
                    <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://33-capital.com/mc-payment-takes-long-view-on-going-cashless/&amp;title=Startup bags funds from Singapore ex-minister to get ultra-wealthy into crowdlending&amp;summary=(Read more at https://www.techinasia.com/helicap-seed-funding) Singapore-based Helicap is a new fintech platform that aims to bring a fund management angle in the peer-to-peer (P2P) lending space. To make this happen, it has raised US$1.5 million in seed funding.&amp;source=https://33-capital.com/mc-payment-takes-long-view-on-going-cashless/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin"></i></a>
                    <a href="https://pinterest.com/pin/create/button/?url=https://33-capital.com/mc-payment-takes-long-view-on-going-cashless/&amp;description=(Read more at https://www.techinasia.com/helicap-seed-funding) Singapore-based Helicap is a new fintech platform that aims to bring a fund management angle in the peer-to-peer (P2P) lending space. To make this happen, it has raised US$1.5 million in seed funding.&amp;media=" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-pinterest"></i></a>
                  </div>                  
                </div>
              </div>
            </div>  
            <hr></hr>
                        <div className="comment-count">
              No Comments           </div>
            <hr></hr>
                        
          </div>
        
        </div>
        
      
      </div>

  

    </div>

  </div>

</div>
</div>

  )
}



// WEBPACK FOOTER //
// ./src/components/News/posts/mcPayment.js